import ServiceProviderWizard from './ServiceProviderWizard'

export default ServiceProviderWizard
